type OmitFromAutoCompleteProp = {
  [key: string]: boolean;
};

export const omitFromAutoComplete: OmitFromAutoCompleteProp = {
  balance: true,
  numberOfKids: true,
  zipCode: true,
};
